import { render } from "./AuthLiquidationDetails.vue?vue&type=template&id=5e85a8fb&scoped=true"
import script from "./AuthLiquidationDetails.vue?vue&type=script&lang=js"
export * from "./AuthLiquidationDetails.vue?vue&type=script&lang=js"

import "./AuthLiquidationDetails.vue?vue&type=style&index=0&id=5e85a8fb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e85a8fb"]])

export default __exports__